var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusEmProducao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "status-em-producao",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1094",
    "data-name": "Grupo 1094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1093",
    "data-name": "Grupo 1093"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1552",
    "data-name": "Caminho 1552",
    d: "M15,9.3V5.7L13.616,5.49a6.413,6.413,0,0,0-.37-.893l.829-1.129L11.532.925,10.4,1.754a6.413,6.413,0,0,0-.893-.37L9.3,0H5.7L5.49,1.384a6.413,6.413,0,0,0-.893.37L3.468.925.925,3.468,1.754,4.6a6.412,6.412,0,0,0-.37.893L0,5.7V9.3l1.384.212a6.414,6.414,0,0,0,.37.893L.925,11.532l2.543,2.543L4.6,13.246a6.417,6.417,0,0,0,.893.37L5.7,15H9.3l.212-1.384a6.413,6.413,0,0,0,.893-.37l1.129.829,2.543-2.543L13.246,10.4a6.416,6.416,0,0,0,.37-.893Zm-2.071-.572L12.853,9a5.527,5.527,0,0,1-.508,1.225l-.139.247.714.972L11.444,12.92l-.972-.714-.247.139A5.529,5.529,0,0,1,9,12.853l-.273.076-.182,1.192H6.456l-.182-1.192L6,12.853a5.529,5.529,0,0,1-1.225-.508l-.247-.139-.972.714L2.08,11.444l.714-.972-.139-.247A5.53,5.53,0,0,1,2.147,9L2.07,8.726.879,8.544V6.456l1.192-.182L2.147,6a5.529,5.529,0,0,1,.508-1.225l.139-.247L2.08,3.556,3.556,2.08l.972.714.247-.139A5.529,5.529,0,0,1,6,2.147l.273-.076L6.456.879H8.544l.182,1.192L9,2.147a5.529,5.529,0,0,1,1.225.508l.247.139.972-.714L12.92,3.556l-.714.972.139.247A5.53,5.53,0,0,1,12.853,6l.076.273,1.192.182V8.544Z",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1096",
    "data-name": "Grupo 1096",
    transform: "translate(3.549 3.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1095",
    "data-name": "Grupo 1095"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1553",
    "data-name": "Caminho 1553",
    d: "M125.088,121.136a3.951,3.951,0,1,0,3.951,3.951A3.956,3.956,0,0,0,125.088,121.136Zm0,7.023a3.072,3.072,0,1,1,3.072-3.072A3.076,3.076,0,0,1,125.088,128.159Z",
    transform: "translate(-121.137 -121.136)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusEmProducao);
export default __webpack_public_path__ + "static/media/status-em-producao.1c47d2025abe73de260affb657681b87.svg";
export { ForwardRef as ReactComponent };